import {
  parsePromoProductRef,
  resolveMenuPickForAssistant,
} from '@/lib/assistantProductFlow';

/**
 * Oferta del día unificada: Promociones (`daily_deal`) → menú público → fallback legacy (`daily_promo_id`).
 * @param {object|null} menuData
 * @returns {object|null}
 */
export function resolveDailyPromoItem(menuData) {
  const dealProduct = menuData?.daily_deal_product;
  if (dealProduct?.name) return dealProduct;

  const business = menuData?.business || {};
  const promos = menuData?.promos || [];
  const products = menuData?.products || [];

  if (business.daily_promo_id) {
    const dailyRef = parsePromoProductRef(business.daily_promo_id);
    const dailyResolved = resolveMenuPickForAssistant(dailyRef, promos, products);
    if (dailyResolved?.item) return dailyResolved.item;
  }

  const dailyPromo = promos.find((p) => p.is_active && p.promo_type === 'daily');
  if (dailyPromo) {
    return {
      ...dailyPromo,
      price: dailyPromo.special_price || dailyPromo.price || 0,
    };
  }
  return null;
}

/**
 * Promo oculta unificada: Promociones (`hidden_promo`) → menú público → fallback legacy (`hidden_promo_id`).
 * @param {object|null} menuData
 * @returns {object|null}
 */
export function resolveHiddenPromoItem(menuData) {
  const hiddenProduct = menuData?.hidden_promo_product;
  if (hiddenProduct?.name) return hiddenProduct;

  const business = menuData?.business || {};
  const promos = menuData?.promos || [];
  const products = menuData?.products || [];

  if (business.hidden_promo_id) {
    const hiddenRef = parsePromoProductRef(business.hidden_promo_id);
    const hiddenResolved = resolveMenuPickForAssistant(hiddenRef, promos, products);
    if (hiddenResolved?.item) return hiddenResolved.item;
  }
  return null;
}

/** Etiqueta corta para UI del dashboard. */
export function formatSpecialPromoLabel(item) {
  if (!item?.name) return null;
  const price = Number(item.final_price ?? item.discount_price ?? item.price) || 0;
  return `${item.name} · $${price.toLocaleString('es-CL')}`;
}
